var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { BenefitCardMW, BenefitCardFullWidthDTW, BenefitCardHalfWidthDTW, } from '../../../shared/rewards-hub';
import { getImageURL } from '../../../../utils/GeneralUtil';
var constants = {
    title: "Account Management",
    headline: "Even doers need help sometimes",
    subtitle: "Get direct access to Account Management services from our experts, available to provide personalized support for your purchasing needs.",
    iconUrl: getImageURL("WelcomeCard/active_AccountManagement.svg"),
};
var AccountManagementMW = function (props) {
    var isLocked = props.isLocked;
    var data = __assign(__assign({}, props), { isLocked: isLocked, iconUrl: constants.iconUrl, title: constants.title, headline: constants.headline, subtitle: constants.subtitle });
    return React.createElement(BenefitCardMW, __assign({}, data));
};
var AccountManagementFullWidthDTW = function (props) {
    var isLocked = props.isLocked;
    var data = __assign(__assign({}, props), { isLocked: isLocked, iconUrl: constants.iconUrl, title: constants.title, headline: constants.headline, subtitle: constants.subtitle });
    return React.createElement(BenefitCardFullWidthDTW, __assign({}, data));
};
var AccountManagementHalfWidthDTW = function (props) {
    var isLocked = props.isLocked;
    var data = __assign(__assign({}, props), { isLocked: isLocked, iconUrl: constants.iconUrl, title: constants.title, subtitle: constants.subtitle });
    return React.createElement(BenefitCardHalfWidthDTW, __assign({}, data));
};
export var AccountManagement = function (props) {
    var isMobile = props.isMobile, isLocked = props.isLocked, fullWidth = props.fullWidth;
    var data = { isMobile: isMobile, isLocked: isLocked };
    if (isMobile)
        return React.createElement(AccountManagementMW, __assign({}, data));
    if (fullWidth)
        return React.createElement(AccountManagementFullWidthDTW, __assign({}, data));
    return React.createElement(AccountManagementHalfWidthDTW, __assign({}, data));
};
